module.exports = __webpack_public_path__ + "static/media/close.76369fd9.svg";